import OwnerPortal from './OwnerPortal';

export default OwnerPortal;
